import 'css-chunksrc/client/scenes/wbs/event/nameEditionForm/styles.scss';export default {
  "nameEditionForm": "_nameEditionForm_14xef_1",
  "form": "_form_14xef_6",
  "hovered": "_hovered_14xef_10",
  "name": "_name_14xef_1",
  "icon": "_icon_14xef_32",
  "input": "_input_14xef_36",
  "edition": "_edition_14xef_57",
  "tooltip": "_tooltip_14xef_64"
};